module.exports = __webpack_public_path__ + "img/solution-eletric-function-bg.c42a1727.png";